// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/custom.css
// module id = 2160
// module chunks = 5